import find from 'lodash/find';
import { constructHeroImageURL } from 'commons/buildHeroImageURL';
import constructImageURLsForVariant from './constructImageURLsForVariant';

const checkImageUrlForProduct = (product, sku, count = 1, forPage) => {
  // Use alternate fallback logic for PDP
  if (forPage === 'pdp') {
    const fabricOptions = find(product.options, { name: 'Fabric' });
    const leatherOpts = find(product.options, { name: 'Leather' });
    const woodOpts = find(product.options, { name: 'Wood' });
    const finalOptions = fabricOptions || leatherOpts || woodOpts || null;

    if (finalOptions) {
      let optionName = find(finalOptions.values[0].option_values, {
        sku: `-${sku.split('-').filter(v => !!v)[0]}`,
      });
      optionName = optionName && optionName.value ? optionName.value : '';
      if (woodOpts && !fabricOptions && !leatherOpts) optionName = '';
      const finalProductImages = {
        ...constructHeroImageURL(product, sku, count, true),
        ...constructImageURLsForVariant(
          product.id,
          sku,
          product.name,
          optionName,
          count
        ),
      };
      return finalProductImages;
    }

    return constructHeroImageURL(product, sku, count);
  }

  const fabricOptions = find(product.options, { name: 'Fabric' });
  if (!fabricOptions && !forPage) {
    return constructHeroImageURL(product, sku, count);
  }

  const defaultSku = {
    ...fabricOptions.values[0].option_values.find(
      fabOpt => +fabOpt.id === +fabricOptions.default_value
    ),
  } || { ...fabricOptions.values[0].option_values[0] };
  let woodStainOpts = find(product.options, { name: 'Wood Stain' });
  if (!woodStainOpts) {
    woodStainOpts = find(product.options, { name: 'Wood' });
  }
  // Type conversion equality check for string / int id mismatch
  let defaultWoodSku = woodStainOpts
    ? woodStainOpts.values[0].option_values.find(
        optVal => +optVal.id === +woodStainOpts.default_value
      )
    : '';
  if (!Object.keys(defaultWoodSku).length) {
    defaultWoodSku = {
      sku: '',
    };
  }
  let finalSku = `${defaultSku.sku}${defaultWoodSku.sku}`;
  if (sku) {
    finalSku = sku;
    // Final option Value name for sku
    const optionSkus = sku.split('-').filter(sk => !!sk);
    const optName = find(fabricOptions.values[0].option_values, {
      sku: `-${optionSkus[0]}`,
    });
    defaultSku.value = optName.value;
  }

  return constructImageURLsForVariant(
    product.id,
    finalSku,
    product.name,
    defaultSku.value,
    count
  );
};

export default checkImageUrlForProduct;
